import Content from "@/components/Content";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

// Dummy Data
const steps = [
    { id: 1, label: "Pendaftaran" },
    { id: 2, label: "Peninjauan Lamaran" },
    { id: 3, label: "Test" },
    { id: 4, label: "Interview" },
    { id: 5, label: "Peninjauan Interview" },
    { id: 6, label: "Diterima" },
];

function VacancyRequirement({ requirements }) {
    return (
        <>
            <h1 className="text-2xl sm:text-3xl font-bold">Requirements</h1>
            <div className="grid grid-cols-2 gap-2 pt-6 font-normal text-gray-400">
                <div className="flex gap-2 items-center">
                    <p className="text-base font-semibold break-words"
                        dangerouslySetInnerHTML={{ __html: requirements || '' }} />
                </div>
            </div>
        </>
    );
}

function VacancyDescription({ jobDesc }) {
    return (
        <>
            <h1 className="text-2xl sm:text-3xl font-bold pt-10">Job Description</h1>
            <div className="font-normal text-gray-400 pt-4">
                <div className="flex gap-2 items-center pt-2">
                    <p className="text-base font-semibold break-words"
                        dangerouslySetInnerHTML={{ __html: jobDesc || '' }} ></p>
                </div>
            </div>
        </>
    );
}

function AboutBusinessUnit({ company, aboutBusinessUnit }) {
    return (
        <div className="block w-full py-5 px-8 bg-white border-primary border-2 rounded-lg">
            <h1 className="text-base font-semibold text-primary mb-2">
                About Business Unit
            </h1>
            <hr className="border-t border-1 border-primary" />
            <h1 className="text-base font-bold pt-2">{company}</h1>
            <p className="text-xs text-gray-500 pt-2 text-justify break-words"
                dangerouslySetInnerHTML={{ __html: aboutBusinessUnit || '' }} />
        </div>
    );
}

const SelectionStage = ({ steps }: { steps: { id: number; label: string }[] }) => {
    return (
        <div className="mt-10">
            <h1 className="text-2xl sm:text-3xl font-bold pt-6">Selection Stage</h1>
            <div
                className=" 
                    grid gap-6 mt-8 md:mt-12 
                    grid-cols-2 md:grid-cols-3
                    place-items-center
                    lg:flex lg:items-center lg:justify-center
                "
            >
                {steps.map((step, index) => (
                    <Step
                        key={step.id}
                        step={step}
                        isLast={index === steps.length - 1}
                    />
                ))}
            </div>
        </div>
    );
};

const Step = ({ step, isLast }: { step: { id: number; label: string }; isLast: boolean }) => (
    <div className="w-full flex items-center justify-center gap-6">
        <div className={`flex flex-col items-center w-full ${isLast ? 'mr-14 lg:mr-0' : ''}`}>
            <div
                className="
                    rounded-full h-24 w-24 
                    flex items-center justify-center 
                    bg-primary text-white 
                    text-lg md:text-3xl
                "
            >
                {step.id}
            </div>
            <span className="block min-h-[5rem] lg:truncate font-semibold text-center text-lg text-primary">
                {step.label}
            </span>
        </div>
        {!isLast && <StepArrow />}
    </div>
);

const StepArrow = () => (
    <>
        <FontAwesomeIcon
            icon={faArrowRight}
            className="w-9 h-9 pb-12 bg text-primary"
        />
    </>
);


export function VacancyDetail({ data }) {
    if (!data) return null;

    return (
        <Content>
            <div className="sm:mt-0 sm:p-8">
                <div className="md:hidden mt-6 mb-8">
                    <AboutBusinessUnit company={data?.company} aboutBusinessUnit={data?.aboutBusinessUnit} />
                </div>

                <div className="pt-2">
                    <div className="grid grid-cols-12 gap-2">
                        <div className="col-span-8">
                            <VacancyRequirement requirements={data?.requirements} />
                            <VacancyDescription jobDesc={data?.jobDesc} />
                        </div>
                        <div className="hidden md:block col-span-4">
                            <AboutBusinessUnit company={data?.company} aboutBusinessUnit={data?.aboutBusinessUnit} />
                        </div>
                    </div>
                </div>

                <SelectionStage steps={steps} />
            </div>
        </Content>
    );
}